import React from 'react'

import HeroStandard  from '@/molecules/Heroes/HeroStandard'

const Hero = (props) => (
  <HeroStandard {...props} />
)

export default Hero
